import { connect } from 'react-redux'

import { sagaSignIn } from '../modules/Auth/actions'
import { Authenticator } from '../components/HOC/Authenticator'

const mapStateToProps = ({ auth }) => {
    return {
        isAuth: auth.isAuth,
        is_logout: auth.is_logout,
        refreshCount: auth.refreshCount,
    }
}

const mapDispatchToProps = {
    sagaSignIn,
}

export default connect(mapStateToProps, mapDispatchToProps)(Authenticator)
